/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Label,Card,Form, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input } from 'reactstrap';
import Alert from 'react-s-alert';
import { useParams } from 'react-router';
// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import PhoneInput from 'react-phone-input-2';

const EditCounsellorProfileIndividual = (props) => {
    // variables
    let timeout = 0;
    //stats
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState({ isVisible: false,index:-1});
    // const [confirmationModal, setConfirmationModal] = useState({ isVisible: false});
    // const [profiles,setProfiles] = useState(data);
    const [pagination, setPagination] = useState({ limit: 3, page: 1, searchVal: "" });
    const [provider,setProvider] = useState({});
    const [isDataModified, setIsDataModified] = useState(false);
    const {uniqueId} = useParams();
    // console.log(uniqueId);
    // contexts
    const { theme } = useContext(ThemeContext);
    
   // useEffects
   useEffect(() => {
        if(!isLoading){
            setIsLoading(true);
            try {
             // console.log(props.stateData);
              setProvider(props.stateData);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
            }
        }
}, [props.stateData]);

    const handleChange = e => {
        try {
            setProvider({ ...provider, [e.target.name]: e.target.value });
            setIsDataModified(true);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddCounsellorProfileIndividual handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handlePhoneChange = e => {
        try {
            setProvider({ ...provider, phone: e });
            setIsDataModified(true);
        
    } catch (err) {
        Alert.error("Some error occured, please try again later or report support team.", {
            position: 'top-right',
            effect: 'slide'
        });
        GeneralService.logError('at Admin AddCounsellorProfileIndividual handlePhoneChange', 'Error in try catch block', err.stack);
    }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            props.setStateData({});
            AdminService.putProfiles(provider).then(data => {
                props.history.replace('scrapedCounsellorProfiles');
                setIsLoading(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
        }
    }

  return (
    <>
        <div className='container-fluid'>
            <h3 className='my-4'>Edit Counsellor Profile</h3>
            <hr />
            
            <div className='px-3 py-5'>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="Name" style={theme.formBodyText}>Name</Label>
                        <Input type='text' name='Name' id='Name' style={theme.formInput} className="w-50" onChange={handleChange}
                        placeholder="Counsellor Name" value={provider.name} required></Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="Address" style={theme.formBodyText}>Address</Label>
                        <Input type='text' name='Address' id='Address' style={theme.formInput}
                        placeholder="Address" className="w-50" onChange={handleChange}  value={provider.address} required></Input>
                    </FormGroup>
                    <FormGroup>
                            <Label for="phone" style={theme.formBodyText} >Phone</Label><br />
                            <div className="d-flex">
                                    <PhoneInput
                                    placeholder={`+91 ${provider.phone}`}
                                    inputClass="form-control w-auto"
                                    inputStyle={theme.formInput}
                                    isValid={(value) => {
                                        if (value.slice(0, 2) !== "91") {
                                            return false;
                                        }
                                        return true;
                                    }}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                    }}
                                    country="in"
                                    disableDropdown={true}
                                    onChange={handlePhoneChange} />
                            </div>
                            
                    </FormGroup>

                    <FormGroup>
                        <Label for="Website" style={theme.formBodyText}>Website</Label>
                        <Input type='text' name='Website' id='Website' style={theme.formInput} 
                        placeholder="https://www.example.com"
                        className="w-50"  onChange={handleChange} value={provider.website} required></Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="UniqueID" style={theme.formBodyText}>UniqueID</Label>
                        <Input type='text' 
                        placeholder="John Deo"name='UniqueID' id='UniqueID' style={theme.formInput} className="w-50"  onChange={handleChange} value={provider.uniqueId} required></Input>
                    </FormGroup>
                    <button className="btn" style={{backgroundColor:"#ffd800"}} type="submit">
                            Add Profile
                    </button>
                </Form>
            </div>
        </div>
    </>
  )
}

export default EditCounsellorProfileIndividual